/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Validation_Tax_Country_FormatInputs */



/**
* | output |
* | --- |
* | "Use a two-letter ISO country code, e.g. DE." |
*
* @param {Partner_Admin_Validation_Tax_Country_FormatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_validation_tax_country_format = /** @type {((inputs?: Partner_Admin_Validation_Tax_Country_FormatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Validation_Tax_Country_FormatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte einen zweistelligen ISO-Ländercode verwenden, z. B. DE.")
	return /** @type {LocalizedString} */ ("Use a two-letter ISO country code, e.g. DE.")
});